module.exports = __webpack_public_path__ + "img/1487.c37c92d3.gif";